import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=f17bffe4&scoped=true&"
import script from "./exam.vue?vue&type=script&lang=js&"
export * from "./exam.vue?vue&type=script&lang=js&"
import style0 from "./exam.vue?vue&type=style&index=0&id=f17bffe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17bffe4",
  null
  
)

export default component.exports